import React, { useState } from "react";

//ANT DESIGN IMPORTS
import { Form, Input, Row, Select, Typography, Checkbox, Col, Tooltip } from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import { labelConfig, staticConfig } from "../../../customer/customer.config";

const { Text } = Typography;

const SettingsForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    lockinPeriodFrequencyTypeOptions,
    minDepositTypeOptions,
    maxDepositTypeOptions,
    inMultiplesOfDepositTermTypeOptions,
    preClosurePenalInterestOnTypeOptions,
    taxGroupOptions,
    withdoldTax,
    handleWitholdTaxChange,
    preClosurePenalInterestStrategyOptions,
  } = props;
  const applyPenalInterest = Form.useWatch("preClosurePenalApplicable", form);
  console.log("applyPenalInterest", applyPenalInterest);
  const [isLockinPeriodSet, setIsLockinPeriodSet] = useState(false);

  const handleLockInPeriodChange = (e) => {
    if (e.target.value > 0) {
      setIsLockinPeriodSet(true);
    } else {
      setIsLockinPeriodSet(false);
    }
  };

  const showValue = (value, option) => {
    console.log("Selected option label:", option?.label);
  };

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
      style={{ margin: 30 }}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Lock-in Period</Text>} name={"lockinPeriodFrequency"}>
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)}
              onChange={handleLockInPeriodChange}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Lock-in Period Frequency Type</Text>}
            name={"lockinPeriodFrequencyType"}
          >
            <Select
              options={lockinPeriodFrequencyTypeOptions}
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.lockinPeriodFrequencyType,
                "select",
              )}
              onChange={showValue}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Minimum Deposit Term</Text>}
            name={"minDepositTerm"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumDepositTerm)} />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Minimum Deposit Term Type</Text>}
            name={"minDepositTermTypeId"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.minimumDepositTermTypes),
              },
            ]}
          >
            <Select
              showSearch
              options={minDepositTypeOptions}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumDepositTermTypes, "select")}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>And Thereafter, In Multiples Of </Text>}
            name={"inMultiplesOfDepositTerm"}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.thereAferTerms)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title="And Thereafter, In Multiples Of">
                <Text strong>{BOM.SubstringFormat("And Thereafter, In Multiples Of", 25)}</Text>
              </Tooltip>
            }
            name={"inMultiplesOfDepositTermTypeId"}
          >
            <Select
              options={inMultiplesOfDepositTermTypeOptions}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.inMultiplesOfType, "select")}
              showSearch
            />
          </Form.Item>
        </Col>
      </Row>

      <Row style={{ justifyContent: "space-between" }}>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Maximum Deposit Term </Text>} name={"maxDepositTerm"}>
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.maximumDepositTerm)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Maximum Deposit Term Type</Text>}
            name={"maxDepositTermTypeId"}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(labelConfig.maximumDepositTermType, "select")}
              options={maxDepositTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="preClosurePenalApplicable"
            label={<Text strong>Apply Penal Interest for Pre-mature Closure?</Text>}
          >
            <Select
              options={staticConfig.yesOrNo}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.preMatureClosure, "select")}
              showSearch
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Apply Penal Interest (less) </Text>}
            name={"preClosurePenalInterest"}
            rules={[
              {
                required: applyPenalInterest,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.penalInterest)} />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>On </Text>}
            name={"preClosurePenalInterestOnTypeId"}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(labelConfig.on, "select")}
              options={preClosurePenalInterestOnTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col> */}
        {applyPenalInterest && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>Penalty Calculation Method </Text>}
              name={"preClosurePenalInterestStrategyId"}
              rules={[
                {
                  required: applyPenalInterest,
                  message: "Required Field",
                },
              ]}
            >
              <Select
                placeholder={BOM.handlePlaceholderMsg("Penalty Calculation Method", "select")}
                options={preClosurePenalInterestStrategyOptions}
                showSearch
              />
            </Form.Item>
          </Col>
        )}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name="withHoldTax" label={<Text strong>Is Withhold Tax Applicable?</Text>}>
            <Select options={staticConfig.yesOrNo} onChange={handleWitholdTaxChange} showSearch />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        {withdoldTax && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>Tax Group</Text>}
              name="taxGroupId"
              rules={[
                {
                  required: true,
                  message: "Required Field",
                },
              ]}
            >
              <Select showSearch options={taxGroupOptions} placeholder={"Please select a value"} />
            </Form.Item>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default SettingsForm;
